import React, { useRef, useState, type ChangeEvent } from "react";
import { DocumentRecord, DOCUMENT_LABELS } from "../types";
import { api, ApiError } from "../api";
import { Spinner } from "../common/ui";

const STATUS_LABEL: Record<string, string> = {
  NOT_UPLOADED: "بارگذاری نشده", UPLOADED: "بارگذاری شد — در انتظار بررسی", PROCESSING: "در حال پردازش",
  NEEDS_CORRECTION: "نیاز به اصلاح", VERIFIED: "تأیید شد", REJECTED: "رد شد", SUPERSEDED: "جایگزین شد",
};

export function DocSlot({
  entityType, entityId, documentType, doc, optional, onChanged,
}: {
  entityType: string;
  entityId?: string;
  documentType: string;
  doc?: DocumentRecord;
  optional?: boolean;
  onChanged: () => void;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const status = doc?.status || "NOT_UPLOADED";

  async function handleFile(e: ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    setError(null);
    try {
      await api.uploadDocument(entityType, entityId, documentType, file);
      onChanged();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "خطا در بارگذاری فایل");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  }

  const boxClass =
    status === "VERIFIED" || status === "UPLOADED" ? "uploaded" : status === "NEEDS_CORRECTION" ? "needs-correction" : "";

  return (
    <div className="field">
      <label>
        {DOCUMENT_LABELS[documentType] || documentType}
        {optional && <span className="source-tag">اختیاری</span>}
      </label>
      <label className={`upload-box ${boxClass}`}>
        <input ref={inputRef} type="file" accept=".pdf,.jpg,.jpeg,.png,.xls,.xlsx" onChange={handleFile} disabled={busy} />
        {busy ? (
          <Spinner />
        ) : status === "NOT_UPLOADED" ? (
          <span>برای بارگذاری کلیک کنید (PDF, JPG, PNG — حداکثر ۲۰ مگابایت)</span>
        ) : (
          <span>{STATUS_LABEL[status]} — برای جایگزینی کلیک کنید</span>
        )}
      </label>
      {doc?.status === "NEEDS_CORRECTION" && <div className="hint" style={{ color: "var(--warning)" }}>این مدرک نیاز به اصلاح دارد؛ لطفاً نسخه جدید بارگذاری کنید.</div>}
      {error && <div className="hint" style={{ color: "var(--error)" }}>{error}</div>}
    </div>
  );
}
